import { ethers } from "ethers";
import { sample } from "lodash";

export const SUPPORTED_CHAINS = [42161, 97];
export const RPC_ENDPOINT = {
  42161: ["https://arbitrum.blockpi.network/v1/rpc/public"],
  97: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
  1:["https://mainnet.infura.io/v3/b6bf7d3508c941499b10025c0776eaf8"]
};

const CHAIN_NAMES = {
  1: "Ethereum Mainnet",
  56: "BNB Smart Chain",
};

const CHAIN_LOGO = {
  1: "/images/networks/eth.svg",
  56: "/images/networks/bsc.png",
};

const SCAN_LOGO = {
  1: "/icons/etherscan.png",
  56: "/icons/bscscan.png",
};

const EXPLORER_URL = {
  1: "https://etherscan.io",
  56: "https://bscscan.com",
  42161: "https://arbiscan.io",
};

export const EXPLORER_API_URL = {
  1: "https://api.etherscan.io/api",
  56: "https://api.bscscan.com/api",
};

export const EXPLORER_API_KEYS = {
  1: "47I5RB52NG9GZ95TEA38EXNKCAT4DMV5RX",
  56: "HQ1F33DXXJGEF74NKMDNI7P8ASS4BHIJND",
};

export const getExplorerLogo = (chainId) => SCAN_LOGO[chainId] ?? "";
export const getChainName = (chainId) => CHAIN_NAMES[chainId] ?? "";
export const getChainLogo = (chainId) => CHAIN_LOGO[chainId] ?? "/images/netowrks/unknown.png";

export const getExplorerLink = (chainId, type, addressOrHash) => {
  const explorerUrl = EXPLORER_URL[chainId];
  switch (type) {
    case "address":
      return `${explorerUrl}/address/${addressOrHash}`;
    case "token":
      return `${explorerUrl}/token/${addressOrHash}`;
    case "transaction":
      return `${explorerUrl}/tx/${addressOrHash}`;
    default:
      return explorerUrl;
  }
};

export const simpleRpcProvider = (chainId) =>
  new ethers.providers.JsonRpcProvider(sample(RPC_ENDPOINT[chainId || 56]));
